import { Box } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { useAppDispatch } from 'store/store';
import { getActiveSubStage, getIsStepperSubStagesOpen } from 'store/ticket-service/selector';
import { setIsStepperSubStagesOpen } from 'store/ticket-service/ticketSlice';

import { NamespacesList } from 'core/enums/common';
import { TicketStepType } from 'core/types/base';

import { ReactComponent as ArrowDown } from 'assets/icons/arrow-down.svg';

import * as Styled from './styled';

export const TicketStep: FC<TicketStepType> = ({
	isStepReady,
	isStepActive,
	onClick,
	title,
	icon,
	selectItems,
}) => {
	const { t: commonTranslate } = useTranslation(NamespacesList['common']);
	const { t: generalStepTranslate } = useTranslation(NamespacesList['generalStep']);

	const dispatch = useAppDispatch();

	const activeSubStage = useSelector(getActiveSubStage);
	const isStepperSubStagesOpen = useSelector(getIsStepperSubStagesOpen);

	const handleSubStageExpand = () => {
		dispatch(setIsStepperSubStagesOpen(!isStepperSubStagesOpen));
	};

	return (
		<Styled.Step
			sx={{ padding: selectItems && isStepReady ? '10px 12px 10px 20px' : '10px 12px 10px 40px' }}
			className="rtl-able"
			onClick={() => (isStepReady && onClick ? onClick() : null)}
			isstepready={Boolean(isStepReady)}
			isstepactive={isStepActive && !isStepperSubStagesOpen}
		>
			{selectItems ? (
				<Box sx={{ display: 'flex', flexDirection: 'column' }}>
					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							gap: '8px',
							marginBottom: isStepperSubStagesOpen ? '8px' : '0',
						}}
					>
						{isStepReady ? (
							<ArrowDown
								onClick={handleSubStageExpand}
								style={{ transform: `rotate(${isStepperSubStagesOpen ? '0deg' : '-90deg'})` }}
							/>
						) : null}
						{icon}
						<Styled.StepTitle isstepready={Boolean(isStepReady)}>
							{commonTranslate(title || '')}
						</Styled.StepTitle>
					</Box>
					<Box sx={{ display: 'flex', flexDirection: 'column' }}>
						{isStepperSubStagesOpen
							? selectItems.map((substage: any, index: number) => (
									<Styled.SubStep
										key={index}
										onClick={() => (substage.isItemReady ? substage.onClick() : null)}
										isstepactive={index === activeSubStage}
										isstepready={substage.isItemReady}
									>
										<Styled.SubStepTitle isstepready={substage.isItemReady}>
											{generalStepTranslate(`substages.${substage.title}`)}
										</Styled.SubStepTitle>
									</Styled.SubStep>
							  ))
							: null}
					</Box>
				</Box>
			) : (
				<>
					{icon}
					<Styled.StepTitle isstepready={Boolean(isStepReady)}>
						{commonTranslate(title || '')}
					</Styled.StepTitle>
				</>
			)}
		</Styled.Step>
	);
};
